import React, { ReactChild } from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";

import styles from "./section.module.scss";

interface SectionProps {
  title: string;
  elRef: any;
  children: ReactChild;
}

const Section = ({ title, children, elRef }: SectionProps) => {
  return (
    <Paper ref={elRef}>
      <h2 className={styles.title}>{title}:</h2>
      <Divider />
      <div className={styles.content}>{children}</div>
    </Paper>
  );
};

export default Section;
